export default __webpack_public_path__ + "static/media/enda.a66c37dd.png";